import React from 'react';
import { Card, Row, Col, Image, Button, Badge } from 'react-bootstrap';


export const TarjetaPresupuestos = (props) => {
	/* Destructuring the props object. */
	const {
		imagenPaciente,
		nombrePaciente,
		telefono,
		direccion,
		localidad,
		precio,
		servicio,
		fecha,
		horasMin,
		activarPresupuestos,
		TipoNotificaciones,
		id,
		cancelarServicio,
		eliminarServicio,
		confirmar,
		rechazarServicio,
		fechaPaciente,
	} = props;

	return (
		// <div className='TarjetaSuperiorPresupuestos'>
		// 	<div className='TarjetaSuperiorDerPresupuestos'>
		// 		<div className='fotoTarjetaPresupuestos centrador'>
		// 			<img src={imagenPaciente} />
		// 		</div>
		// 		<div className='nombreDescripcionTarjetaPresupuestos'>
		// 			<div className='nombreTarjetaPresupuestos'>
		// 				<h4>{nombrePaciente}</h4>
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Fecha de nacimento:</b> {fechaPaciente}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Teléfono: </b> {telefono}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Población: </b> {localidad.nombre}
		// 			</div>
		// 			<div className='descripcionTarjetaPresupuestos'>
		// 				<b>Dirección:</b> {direccion}
		// 			</div>
		// 		</div>
		// 	</div>
		// 	<div className='TarjetaSuperiorIzqPresupuestos'>
		// 		<div className='precioTarjetaPresupuestos'>
		// 			<h4>{servicio}</h4>
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Precio:</b>
		// 			{precio + ' €'}
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Fecha:</b>
		// 			{fecha}
		// 		</div>
		// 		<div className='infoTarjetaPresupuestos'>
		// 			<b>Duración:</b>
		// 			{horasMin + ' minutos'}
		// 		</div>
		// 	</div>
		// 	<div className='buttons-presupuesto'>
		// 		{
		// 			TipoNotificaciones[0] === 'buttonNotificacionesActive' ||
		// 			TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
		// 				<div className='contentBodyCancelarPresupuestos'>
		// 					<div className='servicio-aceptado'>
		// 						<div>Activado</div>
		// 					</div>
		// 				</div>
		// 			) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
		// 				<>
		// 					<div
		// 						className='button'
		// 						onClick={() => activarPresupuestos(id)}
		// 					>
		// 						<b>Activar</b>
		// 					</div>
		// 					<div className='contentBodyCancelarPresupuestos'>
		// 						<div
		// 							className='button borrarCuenta'
		// 							onClick={() => cancelarServicio(id)}
		// 						>
		// 							<div>
		// 								<b>Rechazar</b>
		// 							</div>
		// 						</div>
		// 					</div>
		// 				</>
		// 			) : (
		// 				TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
		// 					<div className='contentBodyCancelarPresupuestos'>
		// 						<div
		// 							className='button borrarCuenta'
		// 							onClick={() => eliminarServicio(id)}
		// 						>
		// 							<div>
		// 								<b>Eliminar</b>
		// 							</div>
		// 						</div>
		// 					</div>
		// 				)
		// 			)
		// 		}
		// 	</div>
		// </div>
		<Card className="p-3 shadow-sm border-0 mb-1">
			<Row className="g-3 align-items-center">
				{/* Columna izquierda: info paciente */}
				<Col md={6} className="d-flex align-items-center">
					<Image src={imagenPaciente} roundedCircle width={80} height={80} className="me-3" />
					<div>
						<h5 className="mb-1">{nombrePaciente}</h5>
						<div><small><strong>Fecha de nacimiento:</strong> {fechaPaciente}</small></div>
						<div><small><strong>Teléfono:</strong> {telefono}</small></div>
						<div><small><strong>Población:</strong> {localidad?.nombre}</small></div>
						<div><small><strong>Dirección:</strong> {direccion}</small></div>
					</div>
				</Col>

				{/* Columna derecha: info servicio */}
				<Col md={4}>
					<h6 className="fw-bold">{servicio}</h6>
					<div><small><strong>Precio:</strong> {precio} €</small></div>
					<div><small><strong>Fecha:</strong> {fecha}</small></div>
					<div><small><strong>Duración:</strong> {horasMin} min</small></div>
				</Col>

				{/* Botones de acción */}
				<Col md={2} className="d-flex flex-column justify-content-center align-items-end">
				<div className="d-flex flex-column gap-2 w-100 align-items-end">
					{TipoNotificaciones[0] === 'buttonNotificacionesActive' || TipoNotificaciones[1] === 'buttonNotificacionesActive' ? (
						<Badge bg="success" className="px-3 py-2">Confirmado</Badge>
					) : TipoNotificaciones[2] === 'buttonNotificacionesActive' ? (
					<div className='d-flex flex-column gap-2'>
						<Button className='btn login-boton' variant="success" size="sm" onClick={() => activarPresupuestos(id)}>
							Confirmar
						</Button>
						<Button variant="danger" size="sm" onClick={() => cancelarServicio(id)}>
							Rechazar
						</Button>
					</div>
					) : TipoNotificaciones[3] === 'buttonNotificacionesActive' && (
					<Button variant="outline-danger" size="sm" onClick={() => eliminarServicio(id)}>
						Eliminar
					</Button>
					)}
				</div>
				</Col>
			</Row>
			</Card>

	);
};
